<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm: -->
        <v-navigation-drawer app v-model="drawer" class="grey lighten-5" disable-resize-watcher>
            <v-list dense class="pt-0">
                <v-list-item class="catabocata-red" @click="onVinateria">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">local_bar</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/vinateria.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Vinatería</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="catabocata-red" @click="onLicoreria">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">local_bar</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/licoreria.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Licorería</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item class="catabocata-red" @click="onCerveceria">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">local_drink</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/cerveceria.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Cervecería</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="catabocata-red" @click="onRestaurante">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">restaurant</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/restaurante2.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Restaurante</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="catabocata-red" @click="onGourmet">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">star_border</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/gourmet2.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Gourmet</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="catabocata-red" @click="onCatalogo">
                    <v-list-item-action>
                        <!-- <v-icon color="red darken-4">star_border</v-icon> -->
                        <img position="left" width="24" src="@/assets/iconos/catalogo.png" />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="cata_2 subtitle-1">#Regalos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm -->

        <v-app-bar flat fixed app color="grey lighten-5" clipped-left>
            <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title class="hidden-sm-and-down">
                <router-link to="/">
                    <img height="55" :src="navMainLogo" />
                </router-link>
            </v-toolbar-title>

            <v-toolbar-title class="hidden-md-and-up">
                <router-link to="/">
                    <img height="35" :src="navMainLogo" />
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text x-large @click="onVinateria" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img position="left" width="24" src="@/assets/iconos/vinateria.png" />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Vinatería</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
                <v-btn text x-large @click="onLicoreria" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img position="left" width="24" src="@/assets/iconos/licoreria.png" />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Licorería</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
                <v-btn text x-large @click="onCerveceria" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img
                                    position="left"
                                    width="24"
                                    src="@/assets/iconos/cerveceria.png"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Cervecería</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
                <v-btn text x-large @click="onRestaurante" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img
                                    position="left"
                                    width="24"
                                    src="@/assets/iconos/restaurante2.png"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Restaurante</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
                <v-btn text x-large @click="onGourmet" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img position="left" width="24" src="@/assets/iconos/gourmet2.png" />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Gourmet</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
                <v-btn text x-large @click="onCatalogo" color="brown darken-3">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <img position="left" width="24" src="@/assets/iconos/catalogo.png" />
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 class="text-none cata_2">#Regalos</v-flex>
                        </v-layout>
                    </v-container>
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>

        <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            activeBtn: 1
        };
    },
    methods: {
        onVinateria() {
            this.$router.push('/vinateria').catch(err => {});
        },
        onLicoreria() {
            this.$router.push('/licoreria').catch(err => {});
        },
        onCerveceria() {
            this.$router.push('/cerveceria').catch(err => {});
        },
        onRestaurante() {
            this.$router.push('/restaurante').catch(err => {});
        },
        onGourmet() {
            this.$router.push('/gourmet').catch(err => {});
        },
        onCatalogo() {
            window.open('http://www.catabocata.com/docs/catalogo.pdf');
        }
    },
    computed: {
        ...mapGetters(['navAppTitle', 'navMainLogo'])
    }
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}
.usr-name {
    font-size: 14px;
    color: #00897b;
}
.catabocata-red {
    color: #bc1212;
    /*BC1212 = 188, 18, 18 */
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    font-size: 1.2em;
    /* font-size: 18px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}
</style>
